import { makeObservable, observable, action, computed } from 'mobx';
import { BasicNodeDto } from '../../types';
import { NodeBaseModel, InputBaseModel } from '..';
import { InputFactory } from '../../factories';
import { SourceModelBase } from '../../../custom_shared/models';

export default class BasicNodeModel extends NodeBaseModel {
    inputs: InputBaseModel[] = [];

    expanded: boolean = true;

    constructor(data: BasicNodeDto, sources: SourceModelBase[]) {
        super(data);

        this.inputs = InputFactory.createInputs(this, data.inputs, sources);

        makeObservable(this, {
            inputs: observable,
            expanded: observable,
            setExpanded: action.bound,
            toggleExpanded: action.bound,
            update: action,
            inputIds: computed
        });
    }

    setExpanded(expanded: boolean) {
        this.expanded = expanded;
    }

    toggleExpanded() {
        this.setExpanded(!this.expanded);
    }

    update(data: BasicNodeDto, sources: SourceModelBase[]) {
        this.inputs = InputFactory.createOrUpdateInputs(this, this.inputs, data.inputs, sources);
    }

    getInputsAtSameLevel() {
        return this.inputs;
    }

    getInputById(id: string) {
        return this.inputs.find(input => input.id === id);
    }

    get inputIds() {
        return this.inputs.map(input => input.id);
    }

    get dto(): BasicNodeDto {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            inputs: this.inputs.map(input => input.dto),
            childNodes: this.childNodes.map(node => node.dto)
        };
    }
}
